import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a7dd87abedae70014d17f07_1787246226901_5b2186fc/techcore/src/app/settings/page.tsx");
